import { css } from 'styled-components';
import { COLORS } from '..';

export const defaultStyle = css`
  outline: none;
  padding: 2px 0;
  text-decoration-thickness: 2px;
  text-decoration-style: solid;
  text-underline-offset: 2px;
  text-decoration-line: none;

  &:link {
    font-weight: 700;
    color: ${COLORS.primary_600};
  }

  &:visited {
    color: ${COLORS.primary_800};
  }

  &:hover,
  &.hover-state {
    color: ${COLORS.primary_700};
    text-decoration-line: underline;
  }

  &:focus,
  &.focus-state {
    border-radius: 2px;
    background: ${COLORS.primary_800};
    color: ${COLORS.white};
  }

  &:active,
  &.active-state {
    border-radius: 2px;
    background: ${COLORS.primary_800};
    color: ${COLORS.white};
  }


  &:focus:hover,
  &:active:hover,
  &.active-state:hover,
  &.focus-state:hover{
    text-decoration-line: none;
    color: ${COLORS.white};
    opacity: 0.9;
  }
`;

export const invertedStyle = css`
  outline: none;
  padding: 2px 0;

  text-decoration-thickness: 2px;
  text-decoration-style: solid;
  text-underline-offset: 2px;
  text-decoration-line: underline;

  &:link {
    font-weight: 700;
    color: ${COLORS.white};
  }

  &:visited {
    color: ${COLORS.neutral_100};
  }

  &:focus,
  &.focus-state {
    border-radius: 2px;
    text-decoration-line: none;
    background: ${COLORS.white};
    color: ${COLORS.neutral_800};
  }

  &:hover,
  &.hover-state {
    text-decoration-line: none;
  }

  &:active,
  &.active-state {
    border-radius: 2px;
    text-decoration-line: none;
    background: ${COLORS.white};
    color: ${COLORS.neutral_800};
  }

  &:focus:hover,
  &:active:hover {
    text-decoration-line: none;
    color: ${COLORS.neutral_800};
    opacity: 0.9;
  }
`;
